import React from "react";
import { Avatar } from "antd";
import {
  StyledModal,
  ModalContentWrapper,
  ModalHeaderSection,
  ModalCustomerInfo,
  ModalCustomerName,
  ModalDisputeId,
  ModalSection,
  ModalSectionTitle,
  ModalSectionText,
  ModalCloseButton,
  StatusTag,
  ModalFooterSpace,
} from "./styles";
import { DisputeDetailsModalProps } from "./types";

const DisputeDetailsModal: React.FC<DisputeDetailsModalProps> = ({
  isOpen,
  onClose,
  dispute,
}) => {
  if (!dispute) return null;

  return (
    <StyledModal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width="100%"
      centered
    >
      <ModalContentWrapper>
        <ModalHeaderSection>
          <Avatar size="large">
            {dispute.customerName.charAt(0).toUpperCase()}
          </Avatar>
          <ModalCustomerInfo>
            <ModalCustomerName>{dispute.customerName}</ModalCustomerName>
            <ModalDisputeId>Dispute ID: {dispute.id}</ModalDisputeId>
          </ModalCustomerInfo>
        </ModalHeaderSection>

        <ModalSection>
          <ModalSectionTitle>{dispute.title}</ModalSectionTitle>
          <ModalSectionText>{dispute.description}</ModalSectionText>
        </ModalSection>

        <ModalSection>
          <ModalSectionText type="secondary">
            Date Submitted: {dispute.dateSubmitted}
          </ModalSectionText>
          <ModalSectionText type="secondary">
            Last Updated: {dispute.lastUpdated}
          </ModalSectionText>
        </ModalSection>

        <ModalSection>
          <ModalSectionTitle>Status:</ModalSectionTitle>
          <StatusTag status={dispute.status}>{dispute.status}</StatusTag>
        </ModalSection>

        <ModalFooterSpace>
          <ModalCloseButton onClick={onClose}>Close</ModalCloseButton>
        </ModalFooterSpace>
      </ModalContentWrapper>
    </StyledModal>
  );
};

export default DisputeDetailsModal;
